import { render, staticRenderFns } from "./StudentContentViews.vue?vue&type=template&id=b47c1090&scoped=true&"
import script from "./StudentContentViews.vue?vue&type=script&lang=js&"
export * from "./StudentContentViews.vue?vue&type=script&lang=js&"
import style0 from "./StudentContentViews.vue?vue&type=style&index=0&id=b47c1090&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47c1090",
  null
  
)

export default component.exports